var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('RangeSlider',{attrs:{"max":_vm.max,"max-value-range":_vm.maxValue,"min":_vm.min,"min-value-range":_vm.minValue,"step":_vm.step,"show-inputs":true},on:{"selectDragging":_vm.selectDragging}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }